<template>
    <div class="page-product">
        <!-- Hero -->
        <div class="hero">
            <div class="container" style="overflow:hidden!important">
            <div class="text-center hideMobile">
              <img src="/static/images/bgX2.png" style="width:100%;max-width:800px;opacity:0.2;position:absolute;z-index:1;">
            </div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="content">
                        <img src="/static/images/laptop_x_iphone.png" style="width:100%;max-width:500px;position:relative;z-index:90;">

                            <p><br/>
                                Et nyt, online redskab der giver dig den indsigt du skal bruge til at<br />
                                tage næste træk for din virksomhed. Det er på tide, at I mødes.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Preview -->
        <preview></preview>

        <!-- Results -->
        <div class="frame">
            <div class="container">
                <div class="row row-eq-height row align-items-center">
                    <div class="col-md-6">
                        <img src="/static/images/preview-results.jpg">
                    </div>

                    <div class="col-md-6">
                        <div class="content">
                            <h3>Alle resultater samlet ét sted</h3>

                            <p>
                                I OP'N finder du alle svar, du har brug for til at drive din forretning. Log ind og se antal besøg på din hjemmeside, antal henvendelser, dit omdømme og effekten af din markedsføring.
                            </p>

                            <ol>
                                <li>Se statistikken for besøg på din hjemmeside</li>
                                <li>Se resultatet af dine Google Adwords</li>
                                <li>Se effekten af dine Facebook-annoncer</li>
                                <li>Se gevinsten af din SEO</li>
                                <li>Se udviklingen i henvendelser</li>
                                <li>Følg dit omdømme på internettet</li>
                                <li>Se statistikken for besøg på din hjemmeside</li>
                            </ol>

                            <p>
                                … og meget mere du kan glæde dig til
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Google results -->
        <div class="frame">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div class="content text-center">
                            <h3>
                                Se om dine Google-placeringer<br />
                                går frem eller tilbage
                            </h3>

                            <p>
                                Med OP'N kan du følge med i dine placeringer på Google inden for søgeord, du selv
                                vælger. Se nemt og hurtigt udbyttet af dit SEO-arbejde og følg med udviklingen. Hver uge.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Results -->
        <div class="frame">
            <div class="container">
                <div class="row row-eq-height row align-items-center">
                    <div class="col-md-6">
                        <div class="content">
                            <h3>Log ind fra din mobil, tablet og computer</h3>

                            <p>
                                Med OP'N har du altid adgang til de resultater og svar, du har brug for til at drive din forretning. Og svarene er ikke langt væk.<br />
                                <br />
                                Log ind med din personlige bruger fra din mobil, tablet eller computer. Weekend og hverdag. Nat og dag
                            </p>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <img src="/static/images/laptop_x_iphone.png">
                    </div>
                </div>
            </div>
        </div>

        <!-- Built for -->
        <div class="frame built-for">
            <div class="container">
                <div class="row row-eq-height row align-items-center">
                    <div class="col-md-12">
                        <div class="content text-center">
                            <h2>Bygget til lokale virksomheder</h2>

                            <p>
                                OP'N er ikke bygget til eksperter i marketing. Det er bygget til de lokale virksomheder.<br />
                                Det garanterer dig, at der kun er ord og oplysninger, du forstår.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Compare results -->
        <div class="frame">
            <div class="container">
                <div class="row row-eq-height row align-items-center">
                    <div class="col-md-6">
                        <img src="/static/images/compare-results.jpg">
                    </div>

                    <div class="col-md-6">
                        <div class="content">
                            <h3>Sammenlign dine resultater med andre</h3>

                            <p>
                                Med OP'N har du mulighed for at sammenligne dine resultater med gennemsnittet for branchen.<br />
                                <br />
                                Det giver dig en bedre idé om din forretning klarer sig godt - eller om det er tid til en ny strategi
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Next move -->
        <div class="frame">
            <div class="container">
                <div class="row row-eq-height row align-items-center">
                    <div class="col-md-6">
                        <div class="content">
                            <h3>Brug dine data til at tage næste træk</h3>

                            <p>
                                Du får en unik og uundværlig indsigt i din markedsføring, hjemmeside og kunder med OP'N.<br />
                                <br />
                                Disse data kan du bruge til at planlægge næste skridt og bygge en strategi, du allerede ved, der kommer til at virke.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <img src="/static/images/next-move.jpg">
                    </div>
                </div>
            </div>
        </div>

        <!-- Sign up -->
        <sign-up></sign-up>
    </div>
</template>

<style lang="scss" scoped>
   @import '~bootstrap/scss/bootstrap.scss';

    .page-product {
        margin-top: 5vh;

        .hero {
            h1 {
                margin-bottom: 40px;

                small {
                    display: block;
                    font-size: 18px;
                    font-weight: 200;
                }
            }

            p {
                font-size: 20px;
                font-weight: 200;
            }
        }

        .frame {
            color: #474747;
            font-size: 16px;

            h3 {
                color: #000;
            }

            img {
                max-width: 90%;
            }

            padding: 90px 0;

            &.built-for {
                padding: 130px 0;
                background: url('/static/images/background-built-for.svg');
                background-position: left bottom;
                background-size: 1500px;
                background-repeat: repeat-x;
                background-color: #F1A1D9;
                color:#fff;

                font-size: 18px;
                font-weight: 200;

                h2 {
                    font-weight: 200 !important;
                    margin-bottom: 20px;
                }
            }
        }

        h3 {
            margin-bottom: 20px;
        }
    }
</style>

<script>
    import Preview from '@/components/Preview'
    import SignUp from '@/components/SignUp'

    export default {
        components: {
            Preview,
            SignUp
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Product.vue